export const getInitialState = (): any => ({
  deployData: {},
  deployStatus: 0
});
